<template>
  <div v-if="recommend.length > 0" class="other-recommend">
    <div class="other-recommend-title">
      <img
        class="img-fluid"
        src="https://static.tpx.tw/sff/squarebear/static/img/you-may-also-like-new.png"
        alt="YOU MAY ALSO LIKE"
      />
    </div>
    <Slick
      ref="slickRecommend"
      class="recommend-slider recommend-slide"
      :options="slideOpts"
      @afterChange="handleAfterChange"
      @beforeChange="handleBeforeChange"
      @breakpoint="handleBreakpoint"
      @destroy="handleDestroy"
      @edge="handleEdge"
      @init="handleInit"
      @reInit="handleReInit"
      @setPosition="handleSetPosition"
      @swipe="handleSwipe"
      @lazyLoaded="handleLazyLoaded"
      @lazyLoadError="handleLazeLoadError"
    >
      <div v-for="recommendItem in recommend" :key="recommendItem.url" class="item-box">
        <div class="inner">
          <div class="item-img-box">
            <a :href="recommendItem.url">
              <new-image :url="recommendItem.image" :size="'_w480_h640'" />
            </a>
          </div>
          <div class="item-info text-left">
            <div class="item-name">
              <a :href="recommendItem.url">{{ recommendItem.name }}</a>
            </div>
            <div class="item-price">
              <span
                v-if="
                  recommendItem.sellPrice !== recommendItem.originPrice ||
                  recommendItem.eventPrice > 0
                "
                class="item__old-price"
              >
                {{ currencyPrice(recommendItem.originPrice, recommendItem.currentCurrency) }}
              </span>
              <span>
                {{
                  currencyPrice(
                    recommendItem.eventPrice > 0 &&
                      recommendItem.eventPrice < recommendItem.sellPrice
                      ? recommendItem.eventPrice
                      : recommendItem.sellPrice,
                    recommendItem.currentCurrency,
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Slick>
  </div>
</template>

<script>
import NewImage from '@global/components/global/image';
import Slick from '@global/vendors/vue-slick';
import { getShopRecommend } from '@global/helpers/recommend';
import {
  fireRecommendByCategoryClickEvent,
  fireRecommendViewGAEventByCategory,
} from '@global/gtm/product';

export default {
  name: 'RecommendApp',
  components: {
    NewImage,
    Slick,
  },
  props: ['alldatas'],
  data() {
    return {
      recommend: [],
      slideOpts: {
        arrows: true,
        dots: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
            },
          },
        ],
      },
    };
  },
  watch: {
    recommend(newVal) {
      if (newVal.length !== 0) {
        fireRecommendViewGAEventByCategory({
          itemListName: `${window.CustomMarketID.split('SZ')[0]} 用戶推薦產品列表`,
          recommendData: this.recommend,
        });

        // 幣別 為了將GTM的幣別換乘TW
        const fireRecommend = this.recommend.map((item) => {
          const newItem = {
            ...item,
            sellPrice: item.sellPriceTW,
          };
          delete newItem.sellPriceTW;
          return newItem;
        });

        this.$nextTick(() => {
          $('.recommend-slider').not('.slick-initialized').slick(this.slideOptions);

          $('.recommend-slider').on('swipe', (event, slick, direction) => {
            fireRecommendByCategoryClickEvent({
              recommendedData: fireRecommend,
              recommendedMove: direction === 'left' ? '推薦商品 More 左滑' : '推薦商品 More 右滑',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.alldatas.Name,
              itemListName: '品牌推薦產品列表',
            });
          });

          $('.recommend-slider .slick-prev').on('click', () => {
            fireRecommendByCategoryClickEvent({
              recommendedData: fireRecommend,
              recommendedMove: '推薦商品 More 左箭頭',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.alldatas.Name,
              itemListName: '品牌推薦產品列表',
            });
          });

          $('.recommend-slider .slick-next').on('click', () => {
            fireRecommendByCategoryClickEvent({
              recommendedData: fireRecommend,
              recommendedMove: '推薦商品 More 右箭頭',
              recommendedType: '產品內頁',
              productId: window.CustomMarketID,
              productName: this.alldatas.Name,
              itemListName: '品牌推薦產品列表',
            });
          });
        });
      }
    },
  },
  created() {
    getShopRecommend().then((recommendData) => {
      this.recommend = recommendData;
    });
  },
  methods: {
    currencyPrice(price, currentCurrency) {
      const priceString = price.toLocaleString();
      let combinePrice = '';
      if (currentCurrency === 'TWD') {
        combinePrice = `NT$ ${priceString}`;
      } else if (currentCurrency === 'USD') {
        combinePrice = `US$ ${priceString}`;
      } else {
        combinePrice = `${priceString}`;
      }
      return combinePrice;
    },
  },
};
</script>
